export default __webpack_public_path__ + "static/media/fomo-group.22c2aa8b.png";